import { createFileRoute } from '@tanstack/react-router';
import { PraiseForm } from '../../../../features/praises';
import { FORM_ORIGINS } from '../../../../lib/form-origins';

export const Route = createFileRoute('/_auth/admin/praises/new')({
  component: () => <PraiseForm mode="create" origin={FORM_ORIGINS.ADMIN} />,
});
